
import { automaticPlanSelector, conflictingParametersSelector } from '../selectors/resolver';
import {
  SELECT_MATERIAL,
  SELECT_EXPRESSION,
  SELECT_COVER_PANEL,
  SELECT_EDGE,
  SELECT_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND,
  SELECT_THICKNESS,
  SELECT_SPLASHBACK,
  SELECT_WALL_PANEL_EXPRESSION,
  SELECT_WALL_PANEL_MATERIAL,
  SELECT_SINK_MATERIAL,
  SELECT_SINK_MODEL,
  SELECT_SINK_FASTENING,
  SELECT_DRAINER_GROOVES,
  CHANGE_SHAPE,
  CHANGE_CUTOUTS,
  CHANGE_SINGLE_CUTS,
  CHANGE_DOUBLE_CUTS,
  CHANGE_TRIPLE_CUTS,
  CHANGE_HIGH_CABINET_JOINTS,
  CHANGE_ROUNDED_CORNERS,
  CHANGE_INVERTED_CORNERS,
  CHANGE_TAP_HOLES,
  CHANGE_WALL_PANEL_ROUND_CUTS_SMALL,
  CHANGE_WALL_PANEL_ROUND_CUTS_BIG,
  CHANGE_WALL_PANEL_SQUARE_CUTS,
  CHANGE_WALL_PANEL_SINGLE_CUTS,
  CHANGE_WALL_PANEL_DOUBLE_CUTS,
  CHANGE_WALL_PANEL_TRIPLE_CUTS,
  SELECT_KITCHEN_ISLAND_MATERIAL,
  SELECT_KITCHEN_ISLAND_THICKNESS,
  SELECT_KITCHEN_ISLAND_EDGE,
  SELECT_KITCHEN_ISLAND_EXPRESSION,
  SELECT_KITCHEN_ISLAND_COVER_PANEL,
  SELECT_OVERHANG,
  SELECT_OVERHANG_SIDE,
  SELECT_WALL_PANEL_MATCH_WORKTOP,
  CHANGE_FREESTANDING_HOBS,
  SELECT_KITCHEN_ISLAND_OVERHANG,
  SELECT_KITCHEN_ISLAND_OVERHANG_SIDE,
} from '../constants';

function conflictResolver(state, action, fullState) {
  switch (action.type) {
    case SELECT_MATERIAL:
    case SELECT_EXPRESSION:
    case SELECT_COVER_PANEL:
    case SELECT_EDGE:
    case SELECT_WALL_LOCATION:
    case SELECT_KITCHEN_ISLAND_WALL_LOCATION:
    case SELECT_KITCHEN_ISLAND:
    case SELECT_KITCHEN_ISLAND_MATERIAL:
    case SELECT_KITCHEN_ISLAND_EXPRESSION:
    case SELECT_KITCHEN_ISLAND_COVER_PANEL:
    case SELECT_KITCHEN_ISLAND_EDGE:
    case SELECT_KITCHEN_ISLAND_THICKNESS:
    case SELECT_KITCHEN_ISLAND_OVERHANG:
    case SELECT_KITCHEN_ISLAND_OVERHANG_SIDE:
    case SELECT_OVERHANG:
    case SELECT_OVERHANG_SIDE:
    case SELECT_THICKNESS:
    case SELECT_SPLASHBACK:
    case SELECT_WALL_PANEL_MATCH_WORKTOP:
    case SELECT_WALL_PANEL_MATERIAL:
    case SELECT_WALL_PANEL_EXPRESSION:
    case SELECT_SINK_MATERIAL:
    case SELECT_SINK_MODEL:
    case SELECT_SINK_FASTENING:
    case SELECT_DRAINER_GROOVES:
    case CHANGE_SHAPE:
    case CHANGE_CUTOUTS:
    case CHANGE_SINGLE_CUTS:
    case CHANGE_DOUBLE_CUTS:
    case CHANGE_TRIPLE_CUTS:
    case CHANGE_HIGH_CABINET_JOINTS:
    case CHANGE_ROUNDED_CORNERS:
    case CHANGE_INVERTED_CORNERS:
    case CHANGE_TAP_HOLES:
    case CHANGE_WALL_PANEL_ROUND_CUTS_SMALL:
    case CHANGE_WALL_PANEL_ROUND_CUTS_BIG:
    case CHANGE_WALL_PANEL_SQUARE_CUTS:
    case CHANGE_WALL_PANEL_SINGLE_CUTS:
    case CHANGE_WALL_PANEL_DOUBLE_CUTS:
    case CHANGE_FREESTANDING_HOBS:
    case CHANGE_WALL_PANEL_TRIPLE_CUTS: {
      const selectorState = fullState.set('businessRules', state);
      const resolvedPlan = automaticPlanSelector(selectorState);
      const conflictsAfterResolve = conflictingParametersSelector(selectorState.setIn(['businessRules', 'plan'], resolvedPlan));
      return state.set('plan', resolvedPlan)
        .setIn(['plan', 'hasChanges'], true)
        .set('planCode', null)
        .setIn(['plan', 'lastActionUpdatedPlan'], true)
        .setIn(['plan', 'conflictMode'], conflictsAfterResolve.size > 0);
    }
    default:
      return state;
  }
}

export default conflictResolver;
